"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreIcon = _interopRequireDefault(require("@legacy-vfuk/core-icon"));

var _coreNumberBadge = _interopRequireDefault(require("@legacy-vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/MobileNavTrigger.style"));

var _constants = require("../../../../constants");

var _TopNavigationContext = _interopRequireDefault(require("../../../../context/TopNavigationContext"));

var _getDataAttributes = _interopRequireDefault(require("../../../../helpers/getDataAttributes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MobileNavTrigger = function MobileNavTrigger() {
  var _ref = (0, _react.useContext)(_TopNavigationContext["default"]),
      primaryNav = _ref.primaryNav,
      mobileNavTrigger = _ref.mobileNavTrigger,
      navLevel = _ref.navLevel,
      setNavLevel = _ref.setNavLevel,
      setActiveNav = _ref.setActiveNav,
      setNavTree = _ref.setNavTree,
      interactionHandler = _ref.interactionHandler,
      dataAttributePrefix = _ref.dataAttributePrefix;

  var getTotalNumberBadges = function getTotalNumberBadges() {
    var numberBadges = primaryNav.links.filter(function (navItem) {
      return navItem.numberBadge;
    });
    return numberBadges.reduce(function (n, _ref2) {
      var numberBadge = _ref2.numberBadge;
      return n + numberBadge;
    }, 0);
  };

  var totalNumberBadges = (0, _react.useMemo)(function () {
    return getTotalNumberBadges();
  }, [primaryNav]);

  var handleClick = function handleClick(event) {
    setNavLevel(1);
    setActiveNav({
      parentId: mobileNavTrigger.id,
      links: primaryNav.links
    });
    setNavTree([{
      level: 1,
      links: primaryNav.links,
      parentId: mobileNavTrigger.id
    }]);
    interactionHandler(event, _constants.DataKeys.MobileNavTrigger);
  };

  return /*#__PURE__*/_react["default"].createElement(Styled.MobileNavTrigger, {
    onInteraction: handleClick,
    id: mobileNavTrigger.id,
    dataAttributes: {
      'data-selector': (0, _getDataAttributes["default"])(_constants.DataKeys.MobileNavTrigger, dataAttributePrefix)
    }
  }, /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
    name: "menu",
    size: 4
  }), /*#__PURE__*/_react["default"].createElement(Styled.MobileNavTriggerText, {
    isActive: navLevel > 0
  }, mobileNavTrigger.text, totalNumberBadges > 0 ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: totalNumberBadges
  })) : null));
};

MobileNavTrigger.displayName = "MobileNavTrigger";
var _default = MobileNavTrigger;
exports["default"] = _default;
//# sourceMappingURL=MobileNavTrigger.js.map